import { render, staticRenderFns } from "./QSummitStepResourcesFooter.vue?vue&type=template&id=0d1fd958&"
import script from "./QSummitStepResourcesFooter.vue?vue&type=script&lang=js&"
export * from "./QSummitStepResourcesFooter.vue?vue&type=script&lang=js&"
import style0 from "./QSummitStepResourcesFooter.vue?vue&type=style&index=0&id=0d1fd958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports